// Build an embeddable iframe URL for a live stream. Returns null when not embeddable.
// Shared by the /watch page and the TopBar live-streamers dropdown preview.
export const buildStreamEmbed = ({ url, platform, channelId, muted = false, autoplay = true }) => {
  const host = typeof window !== "undefined" ? window.location.hostname : "localhost";
  const ap = autoplay ? 1 : 0;
  const mt = muted ? 1 : 0;
  try {
    if (platform === "twitch") {
      const m = (url || "").match(/twitch\.tv\/([A-Za-z0-9_]+)/i);
      if (m) return `https://player.twitch.tv/?channel=${m[1]}&parent=${host}&autoplay=${autoplay}&muted=${muted}`;
    }
    if (platform === "kick") {
      const m = (url || "").match(/kick\.com\/([A-Za-z0-9_]+)/i);
      if (m) return `https://player.kick.com/${m[1]}${muted ? "?muted=true" : ""}`;
    }
    if (platform === "youtube") {
      let vid = null;
      if (url) {
        const w = url.match(/[?&]v=([A-Za-z0-9_-]{6,})/);
        const s = url.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/);
        const l = url.match(/\/live\/([A-Za-z0-9_-]{6,})/);
        const e = url.match(/\/embed\/([A-Za-z0-9_-]{6,})/);
        vid = (w && w[1]) || (s && s[1]) || (l && l[1]) || (e && e[1]);
      }
      if (vid) return `https://www.youtube.com/embed/${vid}?autoplay=${ap}&mute=${mt}`;
      // Fallback: channel-based live embed when we couldn't resolve a video id.
      if (channelId && /^UC[A-Za-z0-9_-]{22}$/.test(channelId)) {
        return `https://www.youtube.com/embed/live_stream?channel=${channelId}&autoplay=${ap}&mute=${mt}`;
      }
    }
  } catch { /* fall through */ }
  return null;
};

export default buildStreamEmbed;
